import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthenticationuser',
  templateUrl: './unauthenticationuser.component.html',
  styleUrls: ['./unauthenticationuser.component.scss']
})
export class UnauthenticationuserComponent implements OnInit {

  private isgraybackground: boolean = false;
  constructor() { }

  ngOnInit() {
    if (localStorage.getItem("PrimaryColor") && localStorage.getItem("SecondaryColor")) {
      //this.isFromDns=localStorage.getItem("isfromDns")
      this.isgraybackground = true;
    }
  }

}
